import { DISPLAY_UNIT, WARNINGS_TYPE } from './general';

export const REQUIRED_TARGET_FIELDS = [
  { fieldName: 'co2Emissions', unit: DISPLAY_UNIT.CO2 },
  { fieldName: 'dwCO2Waste', unit: DISPLAY_UNIT.CO2 },
  { fieldName: 'dwEnergyWaste', unit: DISPLAY_UNIT.ENERGY },
  { fieldName: 'dwFuelWaste', unit: DISPLAY_UNIT.FUEL },
  { fieldName: 'dwNOxWaste', unit: DISPLAY_UNIT.NOX },
  { fieldName: 'energyConsumption', unit: DISPLAY_UNIT.ENERGY },
  { fieldName: 'enginesCO2Waste', unit: DISPLAY_UNIT.CO2 },
  { fieldName: 'enginesEnergyWaste', unit: DISPLAY_UNIT.ENERGY },
  { fieldName: 'enginesFuelWaste', unit: DISPLAY_UNIT.FUEL },
  { fieldName: 'enginesNOxWaste', unit: DISPLAY_UNIT.NOX },
  { fieldName: 'fuelConsumption', unit: DISPLAY_UNIT.FUEL },
  { fieldName: 'hpuCO2Waste', unit: DISPLAY_UNIT.CO2 },
  { fieldName: 'hpuEnergyWaste', unit: DISPLAY_UNIT.ENERGY },
  { fieldName: 'hpuFuelWaste', unit: DISPLAY_UNIT.FUEL },
  { fieldName: 'hpuNOxWaste', unit: DISPLAY_UNIT.NOX },
  { fieldName: 'mudpumpsCO2Waste', unit: DISPLAY_UNIT.CO2 },
  { fieldName: 'mudpumpsEnergyWaste', unit: DISPLAY_UNIT.ENERGY },
  { fieldName: 'mudpumpsFuelWaste', unit: DISPLAY_UNIT.FUEL },
  { fieldName: 'mudpumpsNOxWaste', unit: DISPLAY_UNIT.NOX },
  { fieldName: 'noxEmissions', unit: DISPLAY_UNIT.NOX },
  { fieldName: 'agitatorsCO2Waste', unit: DISPLAY_UNIT.CO2 },
  { fieldName: 'agitatorsEnergyWaste', unit: DISPLAY_UNIT.ENERGY },
  { fieldName: 'agitatorsFuelWaste', unit: DISPLAY_UNIT.FUEL },
  { fieldName: 'agitatorsNOxWaste', unit: DISPLAY_UNIT.NOX }
];

export const TARGET_WASTE_FIELDS = {
  [WARNINGS_TYPE.DW_AUX_Idle]: 'dw',
  [WARNINGS_TYPE.TooManyEng]: 'engines',
  [WARNINGS_TYPE.MP_AUX_Idle]: 'mudpumps',
  [WARNINGS_TYPE.TooManyHPU]: 'hpu',
  [WARNINGS_TYPE.TooManyAgitators]: 'agitators'
};
